import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Modal, Offcanvas } from 'bootstrap';
import { apiService } from '../services/api';
import { OpportunityDetail, CreateOpportunityData } from '../types/opportunity';

export const useOpportunityDetailHandler = (opportunity: OpportunityDetail | null) => {
    const navigate = useNavigate();
    const [editingOpportunity, setEditingOpportunity] = useState<OpportunityDetail | null>(null);
    const [isDeleting, setIsDeleting] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showEditSuccessModal, setShowEditSuccessModal] = useState(false);

    // Preparar oportunidade para edição
    const handlePrepareEdit = () => {
        setEditingOpportunity(opportunity);
    };

    // Atualizar oportunidade
    const handleUpdate = async (updatedData: CreateOpportunityData) => {
        if (!opportunity?.id) return;

        try {

            console.log('DEBUG updatedData Opportunidade:', JSON.stringify(updatedData, null, 2));

            await apiService.updateOpportunity(opportunity.id, updatedData);

            // Fechar offcanvas de edição
            const offcanvasElement = document.getElementById('offcanvas_edit');
            if (offcanvasElement) {
                const offcanvasInstance = Offcanvas.getInstance(offcanvasElement);
                offcanvasInstance?.hide();
            }

            setEditingOpportunity(null);
            setShowEditSuccessModal(true);

            // Recarregar a página usando o navigate
            setTimeout(() => {
                navigate(0); // O '0' faz com que a página atual seja recarregada
            }, 1500);



        } catch (error) {
            console.error('Erro ao atualizar oportunidade:', error);
            alert('Erro ao atualizar a oportunidade. Por favor, tente novamente.');
        }
    };

    // Preparar exclusão
    const handlePrepareDelete = () => {
        setShowDeleteModal(true);
    };

    // Confirmar exclusão
    const handleDelete = async () => {
        if (!opportunity?.id) return;

        try {
            setIsDeleting(true);
            await apiService.deleteOpportunity(opportunity.id);

            setShowDeleteModal(false);
            setShowSuccessModal(true);

            // Redirecionar após um breve delay
            setTimeout(() => {
                navigate('/crm/oportunidades');
            }, 1500);

        } catch (error) {
            console.error('Erro ao excluir oportunidade:', error);
            alert('Erro ao excluir a oportunidade. Por favor, tente novamente.');
        } finally {
            setIsDeleting(false);
        }
    };

    const closeModals = () => {
        document.body.classList.remove('modal-open');
        document.body.style.removeProperty('overflow');
        document.body.style.removeProperty('padding-right');

        const backdrops = document.querySelectorAll('.modal-backdrop');
        backdrops.forEach(backdrop => backdrop.remove());
    };

    return {
        editingOpportunity,
        isDeleting,
        showSuccessModal,
        showDeleteModal,
        showEditSuccessModal,
        handlePrepareEdit,
        handleUpdate,
        handlePrepareDelete,
        handleDelete,
        setShowDeleteModal,
        setShowSuccessModal,
        setShowEditSuccessModal,
        closeModals
    };
};